module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_plan-a5f33072fec8f16955dffeb3c4850dde.jpg";